import { AdditionalUsage } from 'api/odinApi';
import { AddOnProductsDTO } from 'components/SubscriptionAddons/types';
import { SubscriptionSettingsWithCallForwarding } from 'components/SubscriptionSettings/CallForwarding/types';
import { MenuOverview, OdinSubscriptionDetails, Product } from 'interfaces/odinTypes';

interface FixedNetMenuItem extends MenuOverview {
  phoneNumber: string;
}

export const fixedNetMenuItem: FixedNetMenuItem = {
  productType: 'Fixednet',
  phoneNumber: '12345678',
  subscriptionId: 'MOCK_FIXEDNET',
};

interface FixedNetProduct extends Product {
  bsProfileType: string;
}

interface FixedNetSubscription extends OdinSubscriptionDetails {
  product: FixedNetProduct;
  routerName?: string;
  routerVersion?: string;
}

export const fixednetSubscription: FixedNetSubscription = {
  accountNumber: 204045988,
  subscriptionId: 'A3BE00135D97DC5047BA60450246EB7B,SP57_811_01_PSTN_BB,Fixednet',
  phoneNumber: '99192424',
  paysForAccount: true,
  product: {
    groupId: 'FIXED',
    productName: 'Telefoni',
    packageName: 'Bredbånd og Fastnet 50/10, DSL',
    recurringPrice: 0.0,
    packageRecurringPrice: 443.0,
    fairUseLimit: false,
    productParameters: [],
    isCollectiveOffer: false,
    bsProfileType: 'None',
    isOtt: false,
  },
  address: {
    street: 'Fiveabcvej',
    streetNumber: '3',
    city: 'Aalborg',
    zipCode: '9000',
    level: '38',
    side: 'MF',
    houseLetter: '',
    apartmentNumber: '',
    streetCode: '3026',
    municipalityCode: '851',
  },
  broadbandSpeed: {
    uploadMaximumSpeed: 12288,
    uploadMinimumSpeed: 10240,
    downloadMaximumSpeed: 56320,
    downloadMinimumSpeed: 51200,
    uploadExpectedSpeed: null,
    downloadExpectedSpeed: null,
  },
  deliveryText: '',
  youseeClassicAccess: { username: null, isLoggedIn: false },
  lineType: 'Unknown',
  isOfflineSubscription: false,
  encryptedRootLid: 'A3BE00135D97DC5047BA60450246EB7B',
  hasEncryptedCpr: false,
  routerName: '',
  routerVersion: '',
};

export const additionalUsage: AdditionalUsage = {
  currentBillingPeriod: {
    startDate: '2020-05-27T00:00:00+02:00',
    endDate: '2022-08-02T13:37:55.159+02:00',
  },
  additionalUsageTotalAmount: 7.7,
  additionalUsages: [
    {
      description: 'Opkald til mobil',
      totalNumberOfUsages: 4.0,
      totalUsage: 0.0,
      amount: 7.7,
    },
  ],
  hasEuConsumption: false,
};

export const getAddonProductsLandlineMock: AddOnProductsDTO = {
  addOnProducts: [
    {
      productCode: 'AP32_071_00',
      productName: 'Ekstra Service Pakke',
      cmsRef: 'C3207100',
      subscribed: true,
      recurringPrice: 25.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'AddOn',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'anik@nuuday.dk',
      electronicDelivery: false,
    },
    {
      productCode: 'AP89_078_07',
      productName: 'YouSee Fastnet FriTale',
      cmsRef: 'C8907807',
      subscribed: true,
      recurringPrice: 219.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'AddOn',
      oneTimePrice: 950.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'anik@nuuday.dk',
      electronicDelivery: false,
    },
  ],
};

export const productSettingsWithLandlineCallForwarding: SubscriptionSettingsWithCallForwarding = {
  value: {
    forwardRuleAlways: {
      active: false,
      forwardNumber: null,
    },
    forwardRuleBusy: {
      active: true,
      forwardNumber: '45454545',
    },
    forwardRuleNoAnswer: {
      active: true,
      forwardNumber: '42424242',
      timeoutValue: 24,
    },
    hasVoicemail: false,
    validTimeoutValues: [16, 20, 24],
  },
  productCode: 'ODIN_CODE_CALLFORWARDINGLANDLINE',
  productName: 'Viderestilling',
  cmsRef: 'ODIN_CODE_CALLFORWARDINGLANDLINE',
  subscribed: true,
  type: 'CallForwardingLandLine',
  changeCode: null,
  orderId: '',
  orderDate: '0001-01-01T00:00:00',
  settings: [],
};

export const landlineSettingsMock = {
  settings: [
    productSettingsWithLandlineCallForwarding,
    {
      productCode: 'AP99_548_00',
      productName: 'har fravalgt Saldomax',
      cmsRef: 'C9954800',
      subscribed: true,
      type: 'SaldomaxLandline',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP32_621_00',
      productName: 'Vis nummer',
      cmsRef: 'C3262100',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP32_617_00',
      productName: 'aktivering af Voicemail uden svar',
      cmsRef: 'C3261700',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP32_601_00',
      productName: 'Banke På',
      cmsRef: 'C3260100',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP89_100_17',
      productName: 'YouSee FriTale BBT',
      cmsRef: 'C8910017',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'ODIN_CODE_HUA_OMIT',
      productName: 'Udeladt nummer',
      cmsRef: 'ODIN_CODE_HUA_OMIT',
      subscribed: true,
      type: 'UnlistedNumber',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
  ],
};

export const voiceMailInformation = {
  numberOfUncheckedMessages: 0,
  voiceMessagePhoneNumber: '70331401',
  hasEmailNotification: true,
  email: 'test@test.dk',
  hasSmsNotification: true,
  smsNumber: '99199418',
  smsNotificationNumberChangeAllowed: true,
  pinCode: null,
  hasVoiceMail: true,
};
